import React, { useEffect, useState } from 'react';
import { useCoverLetter } from '../../../context/CoverLetterContext';
import PlusIcon from '../../../assets/images/white-plus-icon.svg';
import TickIcon from '../../../assets/images/white-tick-small.svg';


const StrengthsForm = ({data, save}) => {
    let [userStrengths, setUserStrengths] = useState([]);
    // const {
    //     otherdetails,
    //     handlers: {
    //         save,
    //         update2Preview,
    //     },
    // } = useCoverLetter();
    const strengthSet = [
        "Collaboration",
        "Communication",
        "Critical Thinking",
        "Customer Service",
        "Decision-Making",
        "Delegation",
        "Innovation",
        "Interpersonal",
        "Leadership",
        "Management",
        "Motivation",
        "Observation",
        "Organization",
        "Planning",
        "Problem-Solving",
        "Team-Building",
        "Teamwork",
        "Time-Management"
    ]

    // const saveForm = (data) => {
    //     const aiRequestData = { ...otherdetails.ques_ans_response, ...data };
    //     update2Preview({ otherdetails: { ...otherdetails, ques_ans_response: aiRequestData } });
    // }

    // useEffect(() => {
    //     setUserStrengths(otherdetails.ques_ans_response.strengths);
    // }, [otherdetails])

    // const updateUserStrengths = (userStrength) => {
    //     userStrengths = [...userStrengths, userStrength]
    //     setUserStrengths(userStrengths)
    //     saveForm({ strengths: userStrengths })
    //   }

      return(<div className="screen-block">
      {/* //Duplicate screen start  */}
      <div className="skills-list">
        {
          strengthSet.map((strength) => {
            return (
              <div
                className={`skill${data.strengths.indexOf(strength) !== -1 ? " selected" : ''}`}
                onClick={() => {
                  if (data.strengths.indexOf(strength) !== -1) {
                    let temp = data.strengths
                    let rem = temp.indexOf(strength);
                    temp.splice(rem, 1);
                    // setUserSkills(userSkills)
                    save({ strengths: [...temp] })
                  } else {
                    data.strengths.length < 3 && save({ strengths: [...data.strengths, strength] })
                    // console.log(userSkills)
                  }
                }}
                key={`strength-${strength}`}
              >
                <span>
                  {strength}
                  <i className="skill-icon">
                    {data.strengths.indexOf(strength) !== -1 ? <TickIcon /> : <PlusIcon />}
                  </i>
                </span>
              </div>
            )
          })
        }
      </div>
      {/* //Duplicate screen end  */}
    </div>)

}

export default StrengthsForm;